import { render, staticRenderFns } from "./MassMailInhalt.vue?vue&type=template&id=b64b9500&"
import script from "./MassMailInhalt.vue?vue&type=script&lang=js&"
export * from "./MassMailInhalt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports